import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { PageHero } from "@/components/common/SectionHeading";
import { api } from "@/lib/lnlApi";

export default function NewsDetail() {
    const { slug } = useParams();
    const [n, setN] = useState(null);
    useEffect(() => { api.get(`/news/${slug}`).then((r) => setN(r.data)).catch(() => setN(null)); }, [slug]);
    if (!n) return <div className="lnl-container py-16 text-lnl-gray">Loading…</div>;
    return (
        <div data-testid={`news-detail-${slug}`}>
            <PageHero eyebrow={n.category} title={n.title} description={n.summary} breadcrumbs={[{label:"Home",to:"/"},{label:"News",to:"/news"},{label:n.title}]} />
            <section className="py-10 bg-white">
                <div className="lnl-container max-w-3xl">
                    <p className="text-lnl-charcoal leading-relaxed">{n.body}</p>
                    <div className="mt-8 text-sm"><Link to="/news" className="lnl-link">← Back to news</Link></div>
                </div>
            </section>
        </div>
    );
}
